import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulse, Apple, Sparkles, Brain, Sun } from 'lucide-react';
const pillars = [{
  icon: HeartPulse,
  title: 'DESPERTAR DEL CUERPO',
  desc: 'Reconecta con el movimiento desde el placer, no desde el castigo. Rutinas adaptables a tu energía.'
}, {
  icon: Apple,
  title: 'NUTRICIÓN',
  desc: 'Aprende a nutrirte sin restricciones extremas. Comida real para resultados reales y sostenibles.'
}, {
  icon: Sparkles,
  title: 'BIENESTAR',
  desc: 'Hábitos diarios que elevan tu energía, mejoran tu sueño y reducen la inflamación constante.'
}, {
  icon: Brain,
  title: 'MENTE',
  desc: "Reprograma tu diálogo interno. Vence el autosabotaje y la mentalidad de 'todo o nada'."
}, {
  icon: Sun,
  title: 'ESPÍRITU',
  desc: 'Encuentra tu centro. Prácticas de conexión profunda para sostener tu paz en el caos diario.'
}];
export function Mechanism() {
  return <section className="py-24 relative overflow-hidden bg-[#0D1B3E]" data-id="element-168">
      {/* Subtle background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-169">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-170"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-171"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-173">
          <h2 className="font-serif text-3xl md:text-5xl text-cream mb-6" data-id="element-174">
            No es otra dieta. Es un{' '}
            <span className="text-gold italic" data-id="element-175">SISTEMA</span> de 90 días.
          </h2>
          <p className="text-cream/80 text-lg md:text-xl font-light" data-id="element-176">
            El Método RenuevaTE_90 trabaja los 5 pilares que las dietas
            convencionales ignoran. Porque somos seres integrales, y tu
            transformación también debe serlo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16" data-id="element-177">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-cream/5 border border-gold/20 rounded-2xl p-6 text-center hover:bg-cream/10 transition-colors duration-300 backdrop-blur-sm flex flex-col items-center" data-id="element-178">
              <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-179">
                <pillar.icon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-180" />
              </div>
              <h3 className="font-serif text-gold text-lg font-semibold mb-3 h-12 flex items-center justify-center" data-id="element-181">
                {pillar.title}
              </h3>
              <p className="text-cream/70 text-sm leading-relaxed" data-id="element-182">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-gold/10 border border-gold/30 rounded-xl p-6 text-center max-w-4xl mx-auto" data-id="element-183">
          <p className="text-gold font-serif text-xl md:text-2xl tracking-wide" data-id="element-184">
            Estructura + Seguimiento + Acompañamiento ={' '}
            <span className="font-bold" data-id="element-185">Resultados Sostenibles</span>
          </p>
        </motion.div>
      </div>
    </section>;
}